const createCoupon = () =>
  new Vue({
    data: () => {
      return {
        url: "api/v1/discount/coupons",
        couponList: [],
        activeIndex: 0,
        tabList: [
          {
            label: "Available",
            value: 1,
          },
          {
            label: "Unavailable",
            value: 2,
          },
        ],
      };
    },
    created() {
      this.getCoupon(1);
    },
    methods: {
      getCoupon(type) {
        const params = {
          type,
          page: 1,
          rows: 50,
        };
        fetchRequest(this.url, "GET", params).then((response) => {
          if (!response.error) {
            this.couponList = response.data;
          }
        });
      },
      clickTab(item, index) {
        this.activeIndex = index;
        this.getCoupon(item.value);
      },
    },
    template: `
      <div class="content-list right-content hidden" id="my-coupon">
        <div class="flex justify-space-between font-size-20 font-bold">
          <div>My Coupon</div>
        </div>
        <div class="cursor-pointer flex coupon-tab">
          <div class="coupon-tab-item text-center" :class="activeIndex == index?'active':''" v-for="(item, index) in tabList" @click="clickTab(item, index)">{{ item.label }}</div>
        </div>
        <div class="flex coupon-list">
          <div class="coupon-item" :class="coupon.state == 10 ? '': 'disabled'" v-for="coupon in couponList">
            <div class="item-bg flex align-items-center ">
              <div>
                <div class="title">EXCLUSIVE OFFER FOR GOODDIY</div>
                <div class="name">{{coupon.title}}</div>
                <div class="code">code: {{coupon.code}}</div>
                <div class="money">
                  <span class="notranslate">
                    {{ theme.formatPrice(
                      theme.convertCurrency(coupon.discount_value, "usdToSet", true)
                    ) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
      `,
  });

let coupon = null;
